import { render, staticRenderFns } from "./ListKeyResults.vue?vue&type=template&id=589b7f94&"
import script from "./ListKeyResults.vue?vue&type=script&lang=js&"
export * from "./ListKeyResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports